import { Button, Flex, Stack, Text, ThemeIcon } from '@mantine/core'
import { IconCalendarCheck } from '@tabler/icons-react'

import { BENEFIT_TYPE_OPTIONS } from 'src/default/config'

import styles from './appointment-result.module.scss'

interface AppointmentResultProps {
  benefitType: string
  onScheduleNew: () => void
  onViewAppointment: () => void
}

const AppointmentResult = ({
  benefitType,
  onScheduleNew,
  onViewAppointment,
}: AppointmentResultProps) => {
  const message = (() => {
    const currentBenefitType = BENEFIT_TYPE_OPTIONS.find(
      (option) => option.value === benefitType,
    )
    if (!currentBenefitType) {
      return 'The appointment was scheduled successfully.'
    }

    return `The appointment for the ${currentBenefitType.label} Benefit was scheduled successfully.`
  })()

  return (
    <Stack gap="lg" p="md" align="center">
      <ThemeIcon
        size={80}
        radius={80}
        className={styles.successIcon}
        variant="light"
        color="blue"
      >
        <IconCalendarCheck size={45} stroke={1.5} />
      </ThemeIcon>

      <Text size="xl" fw={600} ta="center">
        Appointment Scheduled Successfully!
      </Text>

      <Text size="sm" c="dimmed" ta="center">
        {message}
      </Text>

      <Flex w="100%" justify="space-between" align="center">
        <Button variant="outline" onClick={onScheduleNew}>
          Schedule New Appointment
        </Button>
        <Button onClick={onViewAppointment}>View Opportunity</Button>
      </Flex>
    </Stack>
  )
}

export default AppointmentResult
